export const CONTRACT_APPLICATIONS_API_URL = "/contract-applications"
export const ENERGY_AUDIT_CONTRACTS_API_URL = "/contracts"
export const ENERGY_AUDIT_CONTRACTS_PROGRAMS_API_URL = "/programs"
export const ENERGY_AUDIT_NOTIFICATIONS_API_URL = "/energy-audit-notifications"
export const ENERGY_AUDITS_API_URL = "/energy-audits"
export const ENERGY_PROFILES_API_URL = "/energy-profiles"
export const ENERGY_AUDIT_REQUESTS_API_URL = "/audit-requests"
export const ENERGY_RESOURCES_API_URL = "/energy-resources"
export const OTM_PLAN_ITEMS_API_URL = "/otm-plan-items"
export const OTM_PLAN_API_URL = "/otm-plan"
export const AUDIT_PROCESS_API_URL = "/audit-process"
export const REPORTS_API_URL = "/reports"

export const energyAuditStatusList = [
  "new",
  "search_auditor",
  "contract_signed",
  "program_approvals",
  "audit_in_progress",
  "audit_completed"
  // "done",
  // "expired",
  // "otm"
]

export const list = [
  {
    title: "ООО “Maxsus Energo Auidit”",
    contract_number: 311154712,
    phone_number: "+99878 342 22 34",
    name: "Пример вида деятельности",
    address: "Сырдарьинская область, Баявутский, Энергетиков улица, 7",
    issued: "Центр государственных услуг Сырдарьинской области"
  }
]

export const optionsFormData = {
  headers: {
    "Content-Type": "application/x-www-form-urlencoded"
  }
}

export const energyResourceType = {
  ELECTRICITY: "electricity",
  HEAT: "heat",
  GAS: "gas",
  OIL: "oil",
  COAL: "coal"
}

export const auditStatus = {
  PENDING: "pending",
  REJECTED: "rejected"
}

export const otmPlanStatus = {
  NEW: "new",
  PENDING: "pending",
  ACCEPTED: "accepted",
  REJECTED: "rejected"
}
